import * as Attack from './attack-roll';
import * as Power from './power-roll';

export const Rolls = {
    ...Attack,
    ...Power,
};
